import * as Account from 'app/entities/Account';
import ActionTypes from 'app/dashboard/ActionTypes';
import AuthActions from 'app/auth/AuthActions';
import Data from 'app/dashboard/Data';
import FlowActions from 'app/beta-editor/FlowActions';
import { hasLoadedAuths } from 'app/auth/Selectors';
import { flowIsLoaded, flowIsLoading } from 'app/beta-editor/Selectors';
import {
  selectAreHeldReasonsLoading,
  selectCountsByHeldReason,
  selectHeldTaskStaleAuthServiceNames,
  selectIsHeldTasksBannerOpen,
  selectTotalHeldTasks,
} from 'app/dashboard/Selectors';

const DashboardActions = {
  runZap(zapId) {
    return {
      type: ActionTypes.RUN_ZAP,
      zapId,
      promise: Data.runZap(zapId),
    };
  },

  runZapStatus(zapId) {
    return dispatch => {
      dispatch({
        type: ActionTypes.RUN_ZAP_STATUS,
        zapId,
        promise: Data.runZapStatus(zapId),
      }).then(() => {
        dispatch(DashboardActions.loadHeldReasons());
      });
    };
  },

  loadHeldReasons() {
    return (dispatch, getState) => {
      const state = getState();
      const accountId = Account.selectors.all.currentAccountId(state);
      return (
        !selectAreHeldReasonsLoading(state) &&
        dispatch({
          type: ActionTypes.LOAD_HELD_REASONS,
          promise: Data.loadHeldReasons(accountId),
        })
      );
    };
  },

  loadAllHeldTaskData() {
    return (dispatch, getState) => {
      dispatch(this.loadHeldReasons());

      // Need this to return a list of the services in use by the currently loaded flows for GraphQL fetching
      if (!flowIsLoaded(getState()) && !flowIsLoading(getState())) {
        dispatch(FlowActions.loadZaps());
      }

      // Need this in order to know which stale auths are no longer stale (if we remove, services will be empty and banner won't show)
      if (!hasLoadedAuths(getState())) {
        dispatch(AuthActions.loadAuths());
      }
    };
  },

  handleHeldTasksBannerToggle({ isOpen }) {
    return {
      type: ActionTypes.HANDLE_HELD_TASKS_BANNER_TOGGLE,
      isOpen,
    };
  },

  createHeldTaskSnapshot(snapshot) {
    return {
      type: ActionTypes.CREATE_HELD_TASK_SNAPSHOT,
      snapshot,
    };
  },

  toggleHeldTasksBannerAndCreateSnapshot(services) {
    return (dispatch, getState) => {
      const isOpen = selectIsHeldTasksBannerOpen(getState());

      dispatch(
        DashboardActions.handleHeldTasksBannerToggle({ isOpen: !isOpen })
      );

      const totalHeldTaskCount = selectTotalHeldTasks(getState());
      const countsByHeldReason = selectCountsByHeldReason(getState());
      const staleAuthServiceNames = selectHeldTaskStaleAuthServiceNames(
        getState(),
        services
      );

      const newSnapshot = {
        countsByHeldReason,
        staleAuthServiceNames,
        totalHeldTaskCount,
      };

      dispatch(DashboardActions.createHeldTaskSnapshot(newSnapshot));
    };
  },

  createSnapshot(services) {
    return (dispatch, getState) => {
      const state = getState();
      const totalHeldTaskCount = selectTotalHeldTasks(state);
      const countsByHeldReason = selectCountsByHeldReason(state);
      const staleAuthServiceNames = selectHeldTaskStaleAuthServiceNames(
        state,
        services
      );

      const newSnapshot = {
        countsByHeldReason,
        staleAuthServiceNames,
        totalHeldTaskCount,
      };

      dispatch(DashboardActions.createHeldTaskSnapshot(newSnapshot));
    };
  },
};

export default DashboardActions;
